<template>
  <date-picker
    v-model="range"
    range
    clearable
    :format="format"
    :display-format="displayFormat"
    @change="ChangeDateFilter"
  />
</template>
<script>
export default {

  props: {
    displayFormat: {
      type: String,
      default: 'jYYYY/jM/jD'
    },
    format: {
      type: String,
      default: 'YYYY-MM-DDTHH:mm:ss.sss'
    },
  },

  data() {
    return {
      range: [],
    };
  },
  methods: {
    ChangeDateFilter() {
      this.$emit("ChangeDateFilter", this.range);
    },
  },
};
</script>
<style lang="scss" scoped></style>
